import { Component } from '@angular/core';
import { Toast } from "ngx-toastr"

@Component({
    selector: '[tf-toast-component]',
    styleUrls: ['tf-toast.component.scss'],
    templateUrl: 'tf-toast.component.html'
})
export class TfToastComponent extends Toast {

}
